import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import Link from 'components/link';
import RichText from 'components/rich-text';
import cn from 'classnames';

const imagePositions = {
  left: 'left',
  right: 'right',
};

const ChapterTeaserBlock = ({
  heading,
  textHtml,
  backgroundColor = '#EAF4FA',
  textColor = '#00004F',
  image,
  imagePosition = imagePositions.left,
  readMoreLink,
}) => {
  return (
    <div
      className={cn('chapter-teaser-block', {
        'chapter-teaser-block_no-image': !image,
        [`chapter-teaser-block_image-position_${imagePosition}`]:
          image && imagePosition,
      })}
      style={{ backgroundColor: backgroundColor }}
    >
      <div className="chapter-teaser-block__container">
        <div className="chapter-teaser-block__content">
          <div
            className="chapter-teaser-block__text-container"
            style={{ color: textColor }}
          >
            {heading && (
              <h2 className="chapter-teaser-block__heading">{heading}</h2>
            )}
            <RichText
              text={textHtml}
              className="rich-text_in-chapter-teaser-block"
            />
            {readMoreLink && (
              <div className="chapter-teaser-block__link-holder">
                <Link
                  className="chapter-teaser-block__link"
                  {...readMoreLink}
                />
              </div>
            )}
          </div>
          {image && (
            <div className="chapter-teaser-block__image-container">
              <Image {...image} className="image_size_chapter-teaser-block" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
ChapterTeaserBlock.propTypes = {
  heading: PropTypes.string,
  textHtml: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  imagePosition: PropTypes.oneOf(Object.values(imagePositions)).isRequired,
  readMoreLink: PropTypes.exact(Link.propTypes),
};

export default ChapterTeaserBlock;
